// extracted by mini-css-extract-plugin
module.exports = {"root":"styles_root__3LZLF","colBig":"styles_colBig__3vy4R","colSmall":"styles_colSmall__3dkfB"};